import { Component, Input, OnInit } from '@angular/core';
import { CustomerDetailsModel } from '../customer-details.model';
import { NavigateToCustomerDetails, StorageName } from '../../../../shared/enum/common-enum';
import { AgGridService } from '../../../../shared/common-components/ag-grid/ag-grid.service';
import { StorageService } from '../../../../shared/services/storage.service';
import { BlobOptions } from 'buffer';
@Component({
  selector: 'app-business-details',
  templateUrl: './business-details.component.html',
  styleUrls: ['./business-details.component.scss']
})
export class BusinessDetailsComponent implements OnInit {
  @Input() businessDetails = new CustomerDetailsModel();
  getAllDropdown: any = {};
  storageName = StorageName
  @Input() dropdownnData:any;
  @Input() data:any;
  NavigateToCustomerDetails = NavigateToCustomerDetails;
  constructor(public agGridService: AgGridService,
    public storageService: StorageService) {
  }

  ngOnInit(): void {
    this.getDropdownData()
  }

  handleDateSelection(event:any) {
    this.businessDetails.registrationDate = event;
  }

  getDropdownData() {
    this.agGridService.getAllDropdownList().subscribe(() => {
      this.getAllDropdown.countryDropdown = this.storageService.retrieve(StorageName.COUNTRY_DROPDOWN);
      const installFromDropdown = this.storageService.retrieve(StorageName.INSTALL_FROM_DROPDOWN);
      this.dropdownnData.installFromDropdown = installFromDropdown;
      const installedFrom = this.data?.getAllMinizUserList?.installedFrom;
      if (installedFrom && !this.businessDetails.installedFrom) {
        const selectedOption = installFromDropdown?.find((x: any) => x.id == installedFrom || x.name == installedFrom);
        this.businessDetails.installedFrom = selectedOption?.id;
      }
      if (!installedFrom && !this.businessDetails.installedFrom) {
        const defaultInstall = installFromDropdown?.find((x: any) => x.name === 'SwarnApp');
        this.businessDetails.installedFrom = defaultInstall?.id;
      }
    });
  }

  // Total Amount / Tax Amount / Amount Calculation Area --

  onAmountChange(value: any): void {
    this.businessDetails.amount = value;
    this.calculateAmounts('amount');
  }

  onTaxInPercentChange(value: any): void {
    this.businessDetails.taxInPercent = value;
    this.calculateAmounts('taxInPercent');
  }

  onTotalAmountChange(value: any): void {
    this.businessDetails.totalAmount = value;
  }

  private calculateAmounts(changedField: 'amount' | 'taxInPercent'): void {
    const amount = parseFloat(this.businessDetails.amount as any);
    const taxInPercent = parseFloat(this.businessDetails.taxInPercent as any);
    const hasAmount = !isNaN(amount);
    const hasTax = !isNaN(taxInPercent);
    if (hasAmount && hasTax) {
      const taxValue = (amount * taxInPercent) / 100;
      const total = amount + taxValue;
      this.businessDetails.totalAmount = total.toFixed(2);
    } else if (hasAmount && !hasTax) {
      this.businessDetails.totalAmount = amount.toFixed(2);
    } else {
      this.businessDetails.totalAmount = null;
    }
  }
  // Total Amount / Tax Amount / Amount Calculation Area End --
}


